<nav *ngIf="breadcrumbs.length>1" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs; index as i; last as isLast" class="breadcrumb-item" [ngClass]="{'active': isLast}">
      <a *ngIf="!isLast" href="javascript:void(null)" (click)="routeTo(breadcrumb.url!)">{{breadcrumb.name!}}</a>
      <span *ngIf="isLast">{{breadcrumb.name!}}</span>
    </li>
  </ol>
</nav>
